import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LabelBold, ToggleSwitch } from '@comeon/ui';
import { selectCurrency } from '~/components/account/ducks';
import usePaypalOrderRef from '~/components/payment/hooks/use-paypal-order-ref.js';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';

import { LOADING } from '../utils/constants.js';
import { StyledToggle, PaymentButtonSecondary, PaypalModalWrapper } from '../utils/qd-styled-utils.js';

const QDPaypalscreen = ({ translation: t, views, executeQDDeposit }) => {
	const [enableOneClick, toggleAggr] = useState(false);
	const currency = useSelector(selectCurrency);
	const { status, OrderFuniquedID } = usePaypalOrderRef(true);
	const { trackQDEvent } = usePaymentTracking();

	// Track PayPal modal appearance
	useEffect(() => {
		trackQDEvent({
			pixel_deposit_action: 'paypal-popup-appeared'
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleToggleClick = () => {
		// Track toggle switch click
		trackQDEvent({
			pixel_deposit_action: 'click-paypal-oneclick-toggle',
			pixel_field_validation: `oneclick-toggle:${enableOneClick ? 'disabled' : 'enabled'}`
		});

		toggleAggr(!enableOneClick);
	};

	const setOneClickandExecute = () => {
		// Track PayPal continue button click
		trackQDEvent({
			pixel_deposit_action: 'click-paypal-continue-button',
			pixel_field_validation: `oneclick-toggle:${enableOneClick ? 'enabled' : 'disabled'}`
		});

		executeQDDeposit({ OrderFuniquedID: OrderFuniquedID.current, enableOneClick, cu: currency });
	};

	return (
		<PaypalModalWrapper>
			<StyledToggle className="quick-deposit-cvv-wrapper">
				<ToggleSwitch toggleClass="cookie-toggle" onClick={handleToggleClick} />
				<LabelBold className="u-pt1 u-pl1">{t.QD_PAYPAL_ONECLICK}</LabelBold>
			</StyledToggle>
			<PaymentButtonSecondary
				smallfont
				disabled={views.includes(LOADING) || status !== 'ready'}
				onClick={setOneClickandExecute}
				type="submit"
				className="button u-mb1 u-mt1"
				title="title"
				dataAt="mobile-quick-deposit-button"
			>
				{t.QD_PAYPAL_CONTINUE}
			</PaymentButtonSecondary>
		</PaypalModalWrapper>
	);
};

export default QDPaypalscreen;
